import { Link } from "react-router-dom";
import { Bookmark, Clock } from "lucide-react";
import { timeAgo } from "@/lib/api";

export default function LatestNewsList({ articles = [] }) {
  return (
    <section data-testid="latest-news">
      <div className="flex items-center justify-between mb-4 border-b pb-3" style={{ borderColor: "var(--border)" }}>
        <h2 className="overline">ÚLTIMAS NOTICIAS</h2>
        <Link to="/categoria/actualidad" className="text-sm font-semibold accent-text hover:underline">
          Ver más →
        </Link>
      </div>
      <ul className="space-y-5">
        {articles.map((a, idx) => (
          <li key={a.id}>
            <Link
              to={`/nota/${a.slug}`}
              className="flex gap-4 group"
              data-testid={`latest-item-${a.slug}`}
            >
              <div
                className="w-28 h-20 md:w-44 md:h-28 rounded-sm shrink-0 overflow-hidden"
                style={{ background: "var(--surface-2)" }}
              >
                {a.featured_image && (
                  <img src={a.featured_image} alt={a.title} className="w-full h-full object-cover card-img" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 overline mb-1">
                  <span className="accent-text">{a.category_slug?.toUpperCase()}</span>
                  <span style={{ color: "var(--text-muted)" }}>·</span>
                  <span style={{ color: "var(--text-muted)" }}>{timeAgo(a.published_at)}</span>
                </div>
                <h3 className="font-headline uppercase text-sm md:text-lg leading-tight tracking-tight group-hover:opacity-80" style={{ color: "var(--text)" }}>
                  {a.title}
                </h3>
                {a.bajada && (
                  <p className="hidden md:block text-sm mt-1 line-clamp-2" style={{ color: "var(--text-muted)" }}>
                    {a.bajada}
                  </p>
                )}
                <div className="flex items-center gap-2 mt-2 text-xs" style={{ color: "var(--text-muted)" }}>
                  <Clock size={12} />
                  <span>{a.read_minutes || 2} MIN DE LECTURA</span>
                </div>
              </div>
              <button onClick={(e) => e.preventDefault()} className="self-start mt-1 hover:accent-text transition">
                <Bookmark size={18} />
              </button>
            </Link>
            {idx < articles.length - 1 && (
              <div className="border-t mt-5" style={{ borderColor: "var(--border)" }} />
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
